var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExposureExtended(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-exposure-ext{fill:#7eac20;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-exposure-ext",
    d: "M40.66,65c0-.5,0-1,.05-1.5h-10a1.5,1.5,0,0,0,0,3h10C40.68,66,40.66,65.5,40.66,65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-exposure-ext",
    d: "M100.75,63.5H89.29c0,.5,0,1,0,1.5s0,1,0,1.5h11.46a1.5,1.5,0,0,0,0-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-exposure-ext",
    d: "M47.13,81.5l-7.19,7.19a1.49,1.49,0,0,0,0,2.12,1.5,1.5,0,0,0,2.12,0l7.24-7.24A22.32,22.32,0,0,1,47.13,81.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-exposure-ext",
    d: "M83.57,49.29l8-8a1.51,1.51,0,0,0,0-2.12,1.49,1.49,0,0,0-2.12,0L81.5,47.13A23.41,23.41,0,0,1,83.57,49.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-exposure-ext",
    d: "M83.57,80.7a22.32,22.32,0,0,1-2.07,2.17l7.94,7.94a1.49,1.49,0,0,0,1.06.44,1.53,1.53,0,0,0,1.06-.44,1.51,1.51,0,0,0,0-2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-exposure-ext",
    d: "M47.13,48.5a22.32,22.32,0,0,1,2.17-2.07l-7.24-7.24a1.5,1.5,0,0,0-2.12,2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-exposure-ext",
    d: "M64.25,89.32V100a1.5,1.5,0,0,0,3,0V89.23c-.74.07-1.49.11-2.25.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-exposure-ext",
    d: "M67.25,40.77V30a1.5,1.5,0,0,0-3,0V40.68l.75,0C65.76,40.66,66.51,40.7,67.25,40.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-exposure-ext",
    d: "M50.77,26.37A1.5,1.5,0,1,0,48,27.55l6.7,15.57A24.18,24.18,0,0,1,57.5,42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-exposure-ext",
    d: "M80.73,103.63a1.5,1.5,0,0,0,1.38.91,1.56,1.56,0,0,0,.59-.12,1.5,1.5,0,0,0,.78-2l-7-16.19a23.2,23.2,0,0,1-2.72,1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-exposure-ext",
    d: "M82.47,27.09A1.5,1.5,0,1,0,79.69,26L73.2,42.25A21.77,21.77,0,0,1,76,43.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-exposure-ext",
    d: "M49,102.91a1.51,1.51,0,0,0,.84,2,1.54,1.54,0,0,0,.56.1,1.49,1.49,0,0,0,1.39-.94l6.31-15.84a23.79,23.79,0,0,1-2.82-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-exposure-ext",
    d: "M27.12,80a1.5,1.5,0,0,0,.59,2.88,1.52,1.52,0,0,0,.59-.12l15.26-6.57a23.88,23.88,0,0,1-1.22-2.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-exposure-ext",
    d: "M104.38,50a1.5,1.5,0,0,0-1.18-2.76L86.71,54.35a24.85,24.85,0,0,1,1.15,2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-exposure-ext",
    d: "M27.84,48.27a1.5,1.5,0,0,0-1.11,2.79l15.38,6.13a24.09,24.09,0,0,1,1.15-2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-exposure-ext",
    d: "M104.77,78.94,88.06,72.28A24.91,24.91,0,0,1,87,75.08l16.68,6.65a1.52,1.52,0,0,0,2-.84A1.51,1.51,0,0,0,104.77,78.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-exposure-ext",
    d: "M85.87,63.5a20.89,20.89,0,0,0-4.7-11.8,22.42,22.42,0,0,0-2.09-2.16A20.78,20.78,0,0,0,65,44.06l-.75,0A20.88,20.88,0,0,0,51.7,48.83a22.42,22.42,0,0,0-2.16,2.09A20.84,20.84,0,0,0,44.13,63.5c0,.5-.07,1-.07,1.5s0,1,.07,1.5a20.84,20.84,0,0,0,5.41,12.58,22.42,22.42,0,0,0,2.16,2.09,20.88,20.88,0,0,0,12.55,4.74c.25,0,.5,0,.75,0a20.78,20.78,0,0,0,14.08-5.48,22.42,22.42,0,0,0,2.09-2.16,20.89,20.89,0,0,0,4.7-11.8c0-.5.07-1,.07-1.5S85.9,64,85.87,63.5Zm-3,3A17.85,17.85,0,0,1,79,76.16,18.54,18.54,0,0,1,77,78.34a17.87,17.87,0,0,1-9.71,4.45,18.62,18.62,0,0,1-2.25.15c-.25,0-.5,0-.75,0A17.85,17.85,0,0,1,53.84,79,18.54,18.54,0,0,1,51.66,77,17.87,17.87,0,0,1,47.13,66.5c0-.5-.07-1-.07-1.5s0-1,.07-1.5A17.87,17.87,0,0,1,51.66,53,18.54,18.54,0,0,1,53.84,51a17.85,17.85,0,0,1,10.41-3.88l.75,0a18.62,18.62,0,0,1,2.25.15A17.87,17.87,0,0,1,77,51.66,18.54,18.54,0,0,1,79,53.84a17.85,17.85,0,0,1,3.84,9.66c0,.5.07,1,.07,1.5S82.91,66,82.87,66.5Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExposureExtended);
export default __webpack_public_path__ + "static/media/exposure-extended.78a1bd77.svg";
export { ForwardRef as ReactComponent };